import { useMemo } from 'react'
import { ISyllabus } from '../types'

interface IUseSyllabus {
  (list: ISyllabus['list']): {
    newList: {
      discipline: {
        id: number
        name: string
      }
      hours: number
      optional: boolean
      percent: number
    }[]
  }
}

export const useSyllabus: IUseSyllabus = (list) => {
  const newList = useMemo(() => {
    const hours = list.map((item) => item.hours)

    const max = Math.max(...hours)

    return list.map((item) => {
      return {
        ...item,
        percent: Math.round((item.hours / max) * 100),
      }
    })
  }, [list])

  return {
    newList,
  }
}
